import React from 'react';
import {
  Filter, TextInput,
} from 'react-admin';

const ContactsFilter = props => (
  <Filter {...props}>
    <TextInput label="Search by email" source="q" alwaysOn />
  </Filter>
);

export default ContactsFilter;
